export default "__VITE_ASSET__CCkznfwq__"